import React from 'react'
import DateTime from 'react-datetime'
import InputMask from 'react-input-mask'
import Axios from 'axios'

class ManualRefund extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'subject': 'Повернення квитків',
      'cinema': '0000000026',
      'cinema_name': 'Київ, Жовтень',
      'order': '',
      'card-first': '',
      'card-last': '',
      'amount': '',
      'refund_reason': '',
      'email': '',
      'email_confirmation': '',
      'session_dt': '',
      'purchase_dt': '',
      'name': '',
      'step': 'form',
      'submitting': false,
      invalidity_classes: {
        'order': '',
        'card-first': '',
        'card-last': '',
        'amount': '',
        'refund_reason': '',
        'email': '',
        'email_confirmation': '',
        'session_dt': '',
        'purchase_dt': '',
        'name': '',
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.handlePurchaseDTChange = this.handlePurchaseDTChange.bind(this)
    this.handleSessionDTChange = this.handleSessionDTChange.bind(this)
    this.submit = this.submit.bind(this)
    this.validate = this.validate.bind(this)
    this.hideManualRefund = this.hideManualRefund.bind(this)
    this.getSubmittingClass = this.getSubmittingClass.bind(this)
  }



  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  handlePurchaseDTChange(mmt) {
    this.setState({ 'purchase_dt': mmt.format("YYYY-MM-DD HH:mm") })
  }

  handleSessionDTChange(mmt) {
    this.setState({ 'session_dt': mmt.format("YYYY-MM-DD HH:mm") })
  }

  hideManualRefund() {
    this.props.resetAutoRefundError()
    this.props.hideManualRefund()
  }

  submit() {
    if (this.validate()) {
      let obj = {
        "subject": this.state["subject"],
        "cinema": this.state["cinema"],
        "order": this.state["order"],
        "card-first": this.state["card-first"],
        "card-last": this.state["card-last"],
        "amount": this.state["amount"],
        "refund_reason": this.state["refund_reason"],
        "email": this.state["email"],
        "name": this.state["name"],
        "session_dt": this.state["session_dt"],
        "purchase_dt": this.state["purchase_dt"],
        "cinema_name": this.state["cinema_name"]
      }
      let body = new FormData()
      body.set('data', JSON.stringify(obj))
      this.setState({ 'submitting': true })
      Axios({
        method: 'post',
        url: '/ticket',
        config: { headers: { 'Content-Type': 'multipart/form-data' } },
        data: body
      }).then(res => {
        console.log(res)
        if (res.data.err === "") {
          this.setState({ 'submitting': false })
          this.setState({ step: "success" })
        } else {
          this.setState({ 'submitting': false })
          this.setState({ step: "error" })
        }
      }).catch(error => {
        this.setState({ 'submitting': false })
        this.setState({ step: "error" })
      })
    }
  }

  validate() {
    let NonEmptyFields = ['order', 'card-first', 'card-last', 'amount', 'refund_reason', 'email', 'email_confirmation', 'session_dt', 'purchase_dt', 'name']
    let invalidity_classes = {
      'order': '',
      'card-first': '',
      'card-last': '',
      'amount': '',
      'refund_reason': '',
      'email': '',
      'email_confirmation': '',
      'session_dt': '',
      'purchase_dt': '',
      'name': '',
    }
    this.setState({ invalidity_classes: invalidity_classes })
    let valid = true
    // Не должно быть пустых полей
    for (let field of NonEmptyFields) {
      if (this.state[field] === "") {
        invalidity_classes[field] = "general_err"
        valid = false
      }
    }
    // Должно быть достаточно цифр в номере карты
    if (this.state['card-first'].replace(" ", "").replace("_", "").length < 6) {
      console.log(this.state['card-first'].replace(" ", "").replace("_", ""))
      invalidity_classes['card-first'] = "general_err"
      valid = false
    }
    if (this.state['card-last'].replace(" ", "").replace("_", "").length < 4) {
      invalidity_classes['card-last'] = "general_err"
      valid = false
    }
    // Email должен соответствовать формату
    if (this.state['email'] !== "" && !this.state['email'].match(/[0-9a-z_]+@[0-9a-z_]+\.[a-z]+/i)) {
      invalidity_classes['email'] = "general_err text_err"
      valid = false

    }
    // Email и подтверждение должны совпадать
    if (this.state['email_confirmation'] !== "" && this.state['email'] !== this.state['email_confirmation']) {
      invalidity_classes['email_confirmation'] = "general_err text_err"
      valid = false

    }

    this.setState({ invalidity_classes: invalidity_classes })
    return valid
  }

  getSubmittingClass() {
    if (this.state['submitting']) {
      return ' submitting'
    }
    return ''
  }

  render() {
    return (
      <div className="refund__bg">
        {this.state.step === 'form' && <div className="refund__popup">
          <div className="refund__close" onClick={this.hideManualRefund}></div>
          <p className="refund__heading">Заявка на повернення квитків</p>
          {this.props.autoRefundError && <p className="refund__autoerr">
            На жаль, не вдалось повернути автоматично Ваші квитки.<br />
            Будь-ласка, заповніть заявку для ручного повернення квитків
          </p>}
          <div className="refund__form">
            <input type="hidden" name="subject" value="Повернення квитків" />
            <input type="hidden" name="cinema" value="0000000026" />
            <label className={'label half small_name ' + this.state.invalidity_classes['order']}>
              <p className="name">Номер замовлення</p>
              <input type="tel" required name="order" onChange={this.handleChange} placeholder="Введіть номер замовлення" />
            </label>
            <label className="label half small_name">
              <p className="name">Номер карти</p>
              <div className="card_inputs">
                <div className="card-first">
                  <InputMask mask="9999 99" name="card-first" onChange={this.handleChange} placeholder="XXXX XX" className={this.state.invalidity_classes['card-first']} />
                </div>
                <i></i><i></i><i></i><i></i><i></i><i></i>
                <div className="card-last">
                  <InputMask mask="9999" name="card-last" onChange={this.handleChange} placeholder="XXXX" className={this.state.invalidity_classes['card-last']} />
                </div>
              </div>
              <p className="hint">Перші 6 та останні 4 цифри</p>
            </label>
            <label className={"label full small_name " + this.state.invalidity_classes['amount']}>
              <p className="name">Сума транзакції</p>
              <input type="tel" required name="amount" onChange={this.handleChange} placeholder="0.00 грн" />
            </label>
            <label className={"label half small_name " + this.state.invalidity_classes['session_dt']}>
              <p className="name">Дата і час сеансу</p>
              <DateTime inputProps={{ placeholder: '01.01.2018, 09:00', readOnly: 'readonly' }} name="session_dt" onChange={this.handleSessionDTChange} timeConstraints={{ minutes: { min: 0, max: 59, step: 10 } }} />
            </label>
            <label className={"label half small_name " + this.state.invalidity_classes['purchase_dt']}>
              <p className="name">Час покупки квитка</p>
              <DateTime inputProps={{ placeholder: '01.01.2018, 09:00', readOnly: 'readonly' }} name="purchase_dt" onChange={this.handlePurchaseDTChange} timeConstraints={{ minutes: { min: 0, max: 59, step: 10 } }} />
            </label>
            <label className={"label full small_name " + this.state.invalidity_classes['refund_reason']}>
              <p className="name">Причина повернення</p>
              <input type="text" required name="refund_reason" onChange={this.handleChange} placeholder="Причина повернення" />
            </label>
            <label className={"label half small_name " + this.state.invalidity_classes['email']}>
              <p className="name">Email вказаний при купівлі</p>
              <input type="text" required name="email" onChange={this.handleChange} placeholder="Введiть email " />
              <p className="text_err">Некоректний формат email</p>
            </label>
            <label className={"label half small_name " + this.state.invalidity_classes['email_confirmation']}>
              <p className="name">Підтвердження email</p>
              <input type="text" required name="email_confirmation" onChange={this.handleChange} placeholder="Введiть email ще раз" />
              <p className="text_err">Адреси email не співпадають</p>
            </label>
            <label className={"label full small_name " + this.state.invalidity_classes['name']}>
              <p className="name">Ім’я</p>
              <input type="text" required name="name" onChange={this.handleChange} placeholder="Ваше iм’я" />
            </label>
          </div>
          <div className="refund__buttons">
            <div className={"refund__confirm" + this.getSubmittingClass()} onClick={this.submit}>{this.state.submitting ? 'Надсилаю...' : 'Підтвердити'}</div>
            <div className="refund__cancel" onClick={this.hideManualRefund}>Скасувати</div>
          </div>
        </div>}
        {this.state.step === "success" && <div className="refund__result">
          <p className="refund__result__heading">Дякуємо за звернення!</p>
          <div className="refund__close" onClick={this.hideManualRefund}></div>
          <img src="/img/il_hand.png" className="refund__result__ill" alt="info" />
          <p className="refund__result__description">
            Ваша заявка успішно зареєстрована і буде оброблена протягом 24 годин.<br /><br />
            Як тільки буде здійснено повернення коштів, на Ваш email надійде лист-підтвердження.
          </p>
        </div>}
        {this.state.step === "error" && <div className="refund__result">
          <p className="refund__result__heading">Помилка при обробці заявки</p>
          <div className="refund__close" onClick={this.hideManualRefund}></div>
          <img src="/img/il_hand.png" className="refund__result__ill" alt="info" />
          <p className="refund__result__description">
            Будь-ласка, зверніться за телефоном <a href='tel:+380672475973'>+380 67 247 59 73</a>.<br /><br />
            Дякуємо за розуміння!
          </p>
        </div>}
      </div>
    )
  }
}

export default ManualRefund


// WEBPACK FOOTER //
// ./src/components/snippets/ManualRefund.jsx